import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Male = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="male icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 6C13.6569 6 15 4.65685 15 3C15 1.34315 13.6569 0 12 0C10.3431 0 9 1.34315 9 3C9 4.65685 10.3431 6 12 6ZM8.5 7C7.39543 7 6.5 7.89543 6.5 9V13.2759C6.5 13.7438 6.66403 14.1968 6.96356 14.5563L8.53644 16.4437C8.83597 16.8032 9 17.2562 9 17.7241V22C9 23.1046 9.89543 24 11 24H13C14.1046 24 15 23.1046 15 22V17.7241C15 17.2562 15.164 16.8032 15.4636 16.4437L17.0364 14.5563C17.336 14.1968 17.5 13.7438 17.5 13.2759V9C17.5 7.89543 16.6046 7 15.5 7H8.5Z"
    />
  </svg>
)
